import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 方位角度入力ダイアログ
 * ※方位は、値として保持し、描画に影響はしない
 */
class CompassInputDegrees extends Dialog {
    initDone: boolean = false;// 初期化完了

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      this.initDone = false;

      // ダイアログのコンテンツ生成
      let id = 'compassDegreeInputDialog';
      let title = '角度指定入力';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Input North Direction'; break;
        default: title = '角度指定入力'; break;
      }

      let contents = '<div class="dialogRoomTextSetting">\n';
      contents += '真北(図面上)より<input type="number" id="input_degree"style="width:50px">度';
      contents += '</div>';
      contents += '<div style="width: 80px; height: 80px; margin: auto; padding-top: 20px">';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}/compass_base.png" style="position: absolute">`;
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}/compass_blue.png" style="position: absolute" id="arrowImg">`;
      contents += '</div>';
      let footer = '<button id="btnDoneCompassDegree"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnCompasClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
      this.createDialog(id, title, contents, footer);

      // イベント設定
      const input = document.querySelector('#input_degree');
      input.addEventListener('keyup', this.updateImage);

      const btn = document.querySelector('#btnDoneCompassDegree');
      btn.addEventListener('click', this.updateCompassDirection);

      // 角度の初期値
      let rotationDegree = Number((<HTMLInputElement>document.getElementById('input_degree')).value);
      rotationDegree = marietta.webcad.WebCADGlobal.siteCompass.rotation;
      (<HTMLInputElement>document.getElementById('input_degree')).value = rotationDegree.toLocaleString();
      this.updateImage();

      document.getElementById('btnCompasClose').addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.removeDialog();
      });
      // お掃除
      id = null;
      title = null;
      contents = null;
      footer = null;
    }

    /**
     * イメージの更新
     */
    updateImage = () => {
      const degree: number = Number((<HTMLInputElement>document.getElementById('input_degree')).value);
      const target = document.getElementById('arrowImg');
      target.style.transform = `rotate(${degree}deg)`;
    }

    /**
     * 角度の反映
     */
    updateCompassDirection = () => {
      let degree: number = Number((<HTMLInputElement>document.getElementById('input_degree')).value);
      if (Number.isNaN(degree)) degree = 0;
      if (degree < -360) {
        degree %= (-360);
      }
      if (degree > 360) {
        degree %= (360);
      }
      degree = Math.round(degree);

      marietta.webcad.WebCADGlobal.siteCompass.rotate(degree);

      // 履歴
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

      // ダイアログを閉じる
      this.close();
    }
}

export default CompassInputDegrees;
